const angular = require('angular');

const ProductGroupService = require('./productgroup.service');

angular.module('wowApp.common')
    .service('ProductGroupService', ['Restangular', '$q', 'Settings', 'SortByKeys', ProductGroupService]);



// WEBPACK FOOTER //
// ./src/common/productgroup/index.js